import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  areas = ['Software Development', 'Analytics', 'Tech Consultancy'];
  payment = ['Multiple Installments', 'Mile Stone based', 'Functionality Based', 'Per Hour Charges', 'Lump Sump'];
  solution = {
    'Software Development': [
      'WebSite', 
      'Android Application', 
      'Server For specific Tasks', 
      'Third Party Integrations (Govt API, Payment Gateway, Other Data API)',
      'Software Maintenance', 
      'One time Software Task',
      'Software Enhancement',
      'Server Setup',
      'UI / UX Design'
    ],
    'Analytics':[
      'Data Visualisation',
      'Data Analytics Software',
      'Report Generation Software',
      'Data Insights',
      'Business Insights',
    ],
    'Tech Consultancy':[
      'Selection From Multiple Softwares',
      'Software Design',
      'Software Flow, Data base etc design',
      'Development Process Management',
      'Software Development Management'
    ]
  };
  data = {
    name:'',
    mobile:'',
    email:'',
    sector:'',
    similarApp:'',
    time:'',
    description:'',
    solution:[],
    details:[],
    payment:''
  }
  constructor(private dataSrv: DataService) { }

  ngOnInit() {
  }

  SendEmail(){
    let text = ` <html> <head><style type="text/css">
    .border {
      border-collapse: collapse;
      border: 1px solid #000000;
      text-align: center;
    }
    .borderStyle{
      border: 1px solid #000000;
    }
   </style> <title></title></head>
   <body>
   <p> Hi ${this.data.name}, </p>
   <p> We have received your request, we will reach back to you shortly, You have submitted the following Details:</p>
   <p>Mobile:  ${this.data.mobile}</p>
   <p>Sector Of Application:  ${this.data.sector}</p>
   <p>Requirement Description:  ${this.data.description}</p>
   <p>Time For Completion:  ${this.data.time}</p>
   <p>Similar Application:  ${this.data.similarApp}</p>
   <p>solution requested:  ${this.data.solution.join(", ")}</p>
   <p>Solutions Details:  ${this.data.details.join(", ")}</p>
   <p>Payment Option:  ${this.data.payment}</p>
   <p>Regards,</p>
   <p>Techpixels Private Limited</p>
   </body></html>`
    let request = {
      "mailDetails": {
        "sEmail": this.data.email,
        "sSubject": "Welcome To TechPixels !!",
        "sContent": text
      }
    }
    this.dataSrv.sendEmail(request).subscribe(res => {
      alert("Thanks! we have received your details.");
    },error=>{
      alert("Their was an error, please try again later.");
    });
  }

}



// WEBPACK FOOTER //
// /home/itheunrealist/techpixels/src/app/form/form.component.ts